import { render, staticRenderFns } from "./StagePriceInfo.vue?vue&type=template&id=2dcd32fd&scoped=true&"
import script from "./StagePriceInfo.vue?vue&type=script&lang=js&"
export * from "./StagePriceInfo.vue?vue&type=script&lang=js&"
import style0 from "./StagePriceInfo.vue?vue&type=style&index=0&id=2dcd32fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcd32fd",
  null
  
)

export default component.exports